const mapObj = require('map-obj')
const camelCase = require('camelcase')

const camelCaseConvert = input => mapObj(input, (key, val) => [camelCase(key), val], { deep: true })

const toCamelCase = input => {
  if (!input) return {}

  if (Array.isArray(input)) {
    return Object.keys(input).map(key => camelCaseConvert(input[key]))
  }

  return camelCaseConvert(input)
}

module.exports = toCamelCase
